import { render, staticRenderFns } from "./callSetting.vue?vue&type=template&id=fe93cde8&scoped=true"
import script from "./callSetting.vue?vue&type=script&lang=js"
export * from "./callSetting.vue?vue&type=script&lang=js"
import style0 from "./callSetting.vue?vue&type=style&index=0&id=fe93cde8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe93cde8",
  null
  
)

export default component.exports